export default __webpack_public_path__ + "static/media/Vinay.2d3b65ac.png";